<template>
  <div>
    <n-bread v-bind:content="{ bread_list, bread_active }"></n-bread>
    <n-modal-team
      v-if="formData"
      v-bind:content="{ formData: formData, myError: myError }"
      @closeModal="closeModal"
    ></n-modal-team>
    <n-modal-delete
      @closeModal="closeModal"
      @deleteResource="deleteTeam"
    ></n-modal-delete>
    <div class="card abtg__default-card abtg__default-card-border">
      <div class="card-head">
        <header>{{ $t("team.title") }}</header>
        <div class="abtg__header_popover">
          <popover
            module="team"
            content="myTeam"
            color="grey"
            position="right"
          ></popover>
        </div>
        <div class="tools">
          <a
            @click="newTeam()"
            href="#"
            class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool"
          >
            {{ $t("team.new_member") }}</a
          >
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="
              mdl-data-table
              ml-table-striped ml-table-bordered
              mdl-js-data-table
              is-upgraded
              abtg__table-noborder
            "
          >
            <thead>
              <tr>
                <th class="mdl-data-table__cell--non-numeric text-left">
                  {{ $t("team.name") }}
                </th>
                <th class="mdl-data-table__cell--non-numeric text-left">
                  {{ $t("team.email") }}
                </th>
                <th class="mdl-data-table__cell--non-numeric text-left">
                  {{ $t("team.profession") }}
                </th>
                <th
                  class="mdl-data-table__cell--non-numeric text-left"
                  v-html="$t('team.phone')"
                ></th>
                <th class="mdl-data-table__cell--non-numeric text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, index) in teamList">
                <td class="mdl-data-table__cell--non-numeric align-top">
                  <strong>{{ u.name }}</strong>
                </td>
                <td class="align-top">
                  {{ u.email }}
                </td>
                <td class="mdl-data-table__cell--non-numeric align-top">
                  {{ u.profession }}
                </td>

                <td class="mdl-data-table__cell--non-numeric align-top">
                  <strong>{{ u.phone }}</strong>
                </td>

                <td class="align-top">
                  <div class="" role="group" aria-label="Basic example">
                    <a class="margin-right-10" href="#" @click="editTeam(u)">
                      <i class="fas fa-pencil-alt"></i>
                    </a>
                    <a
                      class="margin-right-10"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      @click="prepareToDelete(u)"
                    >
                      <i class="far fa-trash-alt"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NBread from "@/partials/bread";
import Popover from "@/partials/popover";
import NModalTeam from "@/partials/team/modal_team";
import NModalDelete from "@/partials/modal_delete";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  created() {
    this.lang = window.localStorage.getItem("language");
    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Mi equipo" },
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Il mio Team" },
      });
    }

    this.classicList();
  },
  components: {
    NBread,
    Popover,
    NModalTeam,
    NModalDelete,
  },
  computed: {
    ...mapState("n_team", [
      "bread_active",
      "bread_list",
      "teamList",
      "formData",
      "myError",
      "idTeamToDelete",
    ]),
  },
  methods: {
    ...mapActions("n_team", ["classicList", "deleteTeam"]),
    ...mapMutations("n_team", ["SET_DATA"]),

    newTeam() {
      this.SET_DATA({ name: "formData", data: {} });
      this.showModal("m-team");
    },
    showModal(modalName) {
      this.$modal.show(modalName);
    },
    closeModal(modalName) {
      this.$modal.hide(modalName);
    },
    prepareToDelete(payload) {
      this.SET_DATA({ name: "idTeamToDelete", data: payload.id });
      this.showModal("m-delete");
    },
    editTeam(payload) {
      this.SET_DATA({ name: "formData", data: payload });
      this.showModal("m-team");
    },
  },
};
</script>
